import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { parse } from 'diff2html';
import {
  diffComponent,
  getComponentById,
  getComponentList,
  getVariableList,
} from '@/services/templateService';

const initialState = {
  components: [],
  variables: [],
  cache: {},
  diff: [],
  currentFlowGroups: [],
};

export const fetchComponentList = createAsyncThunk(
  'template/fetchComponentList',
  async (params) => {
    const response = await getComponentList(params);
    return response.data.items;
  },
);

export const fetchVariableList = createAsyncThunk('template/fetchVariableList', async (id) => {
  const response = await getVariableList(id);
  return response.data;
});

export const fetchComponentById = createAsyncThunk('template/fetchComponentById', async (id) => {
  const { data } = await getComponentById(id);
  return data;
});

export const fetchComponentDiff = createAsyncThunk(
  'template/fetchComponentDiff',
  async (params) => {
    const { data = [] } = await diffComponent(params);
    return data.map((item) => parse(item.join('\n'))).flat();
  },
);

export const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    cacheStep: (state, action) => {
      const { step, data } = action.payload;
      state.cache[step] = data;
    },
    cleanCache: (state) => {
      state.cache = {};
      state.diff = [];
    },
    setCurrentFlowGroups: (state, action) => {
      state.currentFlowGroups = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComponentList.fulfilled, (state, action) => {
        state.components = action.payload.map((item) => ({
          ...item,
          label: item.name,
          value: item.name,
        }));
      })
      .addCase(fetchVariableList.fulfilled, (state, action) => {
        state.variables = action.payload.map((item) => ({
          ...item,
          label: item.key,
          value: item.key,
        }));
      })
      .addCase(fetchComponentDiff.fulfilled, (state, action) => {
        state.diff = action.payload;
      })

      .addCase(fetchComponentById.fulfilled, (state, action) => {
        const data = action.payload;
        // 拆解cache步骤
        const cache = {
          0: {
            name: data.name,
            type: data.type,
            note: data.note,
            deployDir: data.deployDir,
            repoDir: data.repoDir,
            reservedVersionNum: data.reservedVersionNum,
          },
          1: {
            variableSubstitutionPath: data.variableSubstitutionPath,
            packageVariables: data.packageVariableVOList || [],
            ipVariables: data.ipVariableVOList || [],
          },
          2: {
            scriptCreateBOList: data.scriptVOList.slice(0, 6),
          },
          3: {
            scriptCreateBOList: data.scriptVOList.slice(6, 12),
          },
          4: {
            scriptCreateBOList: data.scriptVOList.slice(12, 18),
          },
          5: {
            scriptCreateBOList: data.scriptVOList.slice(18, 19),
          },
          6: {
            scriptCreateBOList: data.scriptVOList.slice(19, 20),
          },
          7: {
            scriptCreateBOList: data.scriptVOList.slice(20, 21),
          },
        };
        state.cache = cache;
      });
  },
});

export const { cacheStep, cleanCache, setCurrentFlowGroups } = templateSlice.actions;
export default templateSlice.reducer;
